import { render, staticRenderFns } from "./BContainer.vue?vue&type=template&id=2852945e&"
import script from "./BContainer.vue?vue&type=script&lang=ts&"
export * from "./BContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports